export const getO2UIVersion = () => `O2 UI ${process.env.NPM_PACKAGE_VERSION}`;
